<template>
  <div class="page-wrapper">
    <PageHeader />
    <div class="form-page-wrap">
      <div class="form-card">
        <div class="success-icon">✓</div>
        <div class="success-title">注册成功！</div>
        <div class="success-desc">
          您的账号已成功注册<br />
          现在可以使用账号登录，享受全站服务
        </div>
        <button class="form-btn" @click="$router.push('/login')">立即登录</button>
        <div class="form-links" style="margin-top:14px; justify-content:center;">
          <router-link class="form-link" to="/">返回首页</router-link>
        </div>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import PageHeader from '@/views/detail/components/PageHeader.vue'
import PageFooter from '@/views/detail/components/PageFooter.vue'

export default {
  name: 'RegisterSuccess',
  components: { PageHeader, PageFooter }
}
</script>

<style scoped>
@import './form.css';
.page-wrapper { display: flex; flex-direction: column; min-height: 100vh; }
.form-page-wrap { flex: 1; }
.success-icon {
  color: rgba(160, 0, 0, 1);
  background: rgba(160, 0, 0, 0.08);
  font-size: 40px;
  line-height: 80px;
  text-align: center;
}
</style>
